function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgEditIcon = function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.3601 3.07866L14.2869 2.15178C15.8226 0.616074 18.3125 0.616074 19.8482 2.15178C21.3839 3.68748 21.3839 6.17735 19.8482 7.71306L18.9213 8.63993M13.3601 3.07866C13.3601 3.07866 13.4759 5.04828 15.2138 6.78618C16.9517 8.52407 18.9213 8.63993 18.9213 8.63993M13.3601 3.07866L4.83882 11.5999C4.26166 12.1771 3.97308 12.4656 3.7249 12.7838C3.43214 13.1592 3.18114 13.5653 2.97634 13.995C2.80273 14.3593 2.67368 14.7465 2.41556 15.5208L1.58917 18M18.9213 8.63993L10.4001 17.1612C9.82294 17.7383 9.53436 18.0269 9.21617 18.2751C8.84082 18.5679 8.43469 18.8189 8.00498 19.0237C7.6407 19.1973 7.25352 19.3263 6.47918 19.5844L4 20.4108M4 20.4108L2.39584 20.9456C2.01478 21.0726 1.59466 20.9734 1.31063 20.6894C1.0266 20.4053 0.927428 19.9852 1.05445 19.6042L1.58917 18M4 20.4108L5.36661 19.9553L1.9225 17L1.58917 18",
    stroke: "currentColor",
    strokeWidth: 1.5
  }));
};
export default SvgEditIcon;